import { IconActionSearch } from "@/components/Icons";
import React from "react";

interface Props {
  onChange: (newValue: string) => void;
  value: string;
}

export function SearchBar(props: Props) {
  const { onChange, value } = props;
  return (
    <div className={"w-full flex text-white"}>
      <label 
        className={"sr-only"}
        htmlFor={"searchInput"}
      >
        Search learning opportunity
      </label>
      <input
        id={"searchInput"}
        value={value}
        onChange={(event) => {
          const newQuery = event.currentTarget.value;
          onChange(newQuery);
        }}
        type={"text"}
        placeholder={"Search by title..."}
        className={
          "w-full bg-light-blue rounded-t-2 h-[48px] border-b border-yellow-90 p-3 pl-[42px] hover:bg-light-blue/90 outline-0 focus-visible:ring-[1px] ring-yellow-90 peer placeholder-white/90"
        }
      />
      <IconActionSearch
        className={
          "h-lg w-lg absolute mt-[14px] ml-sm peer-focus-visible:text-yellow-90"
        }
      />
    </div>
  );
}
